import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import * as Steps from '../NeedsAnalysis/steps/index';
import { getSessionStorageItem, SESSION_STORAGE_NEEDS_ANALYSIS_KEY } from '../../../sessionStorage';
import { HeaderProgressTracker } from '../../Common/HeaderStepper/HeaderProgressTracker';
import StartOverButton from './StartOverButton';
import './NeedsAnalysis.scss';

export default function NeedsAnalysis(props) {

  const path = props.location ? props.location.pathname.split('/').pop() : null;

  const sessionStorageFormState = getSessionStorageItem(SESSION_STORAGE_NEEDS_ANALYSIS_KEY);
  const prefill = props.location.search && props.location.search.toLowerCase().includes('prefill');

  const newFormState = {
    currentStep: 1,
    pages: {
      clientBasicInfo: Steps.ClientBasicInfo.DefaultFormState(prefill),
      financialInfo: Steps.FinancialInfo.DefaultFormState(prefill),
      currentInsurance: Steps.CurrentInsurance.DefaultFormState(prefill),
      additionalClientInfo: Steps.AdditionalClientInfo.DefaultFormState(prefill),
      monthlyExpenses: Steps.MonthlyExpenses.DefaultFormState(prefill),
      quoter : Steps.Quoter.DefaultFormState(),
      advisor : Steps.Advisor.DefaultFormState(),
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const initialFormState = sessionStorageFormState || newFormState;

  const [formState, setFormState] = useState(initialFormState);

  // update the formState when the url path changes the step
  useEffect(() => {
    if (!path) {
      return;
    }

    const nextStep = steps.find(s => s.path === path);

    if (!nextStep) {
      return;
    }
    const newFormState = { ...formState, currentStep: nextStep.step };
    setFormState(newFormState);
  }, [path]);

  const onNext = () => {
    let nextStep = 0;
    nextStep = steps.find(s => s.step === formState.currentStep + 1);
    if(nextStep.path ==='additional-info' && formState.pages.financialInfo.hasAdditionalClientInfoStep !== true)
    {
      nextStep = steps.find(s => s.step === nextStep.step + 1);
    }
     if(nextStep.path ==='monthly-expenses' && formState.pages.financialInfo.hasMonthlyExpensesStep !== true)
    {
      nextStep = steps.find(s => s.step === nextStep.step + 1);
    }

    if (!nextStep) {
      throw new Error('onNext did not find a next step');
    }

    const newFormState = { ...formState, currentStep: nextStep.step };

    setFormState(newFormState);
    sessionStorage.setItem(SESSION_STORAGE_NEEDS_ANALYSIS_KEY, JSON.stringify(newFormState));

    props.history.push(`/InsuranceTools/NeedsAnalysis/${nextStep.path}`);
    window.scroll(0, 0);
  };

  const onBack = () => {
    let backStep = steps.find(s => s.step === formState.currentStep - 1);
    if (backStep) {
      const newFormState = { ...formState, currentStep: backStep.step };
      if(backStep.path ==='additional-info' && formState.pages.financialInfo.hasAdditionalClientInfoStep !== true)
      {
        backStep = steps.find(s => s.step === backStep.step - 1);
      }
       if(backStep.path ==='monthly-expenses' && formState.pages.financialInfo.hasMonthlyExpensesStep !== true)
      {
        backStep = steps.find(s => s.step === backStep.step - 1);
      }
      setFormState(newFormState);
      sessionStorage.setItem(SESSION_STORAGE_NEEDS_ANALYSIS_KEY, JSON.stringify(newFormState));

      let redirect = `${backStep.path}`;
      props.history.push(`/InsuranceTools/NeedsAnalysis/${redirect}`);
      window.scroll(0, 0);
    } else {
      props.history.push('/ResourceCenter');
      props.setActiveLink(props.navLinks.findIndex((a) => a.text === 'Resource Center'));
    }
  };

  const onFieldChange = (step, field, value) => {
    setFormState({ ...formState, pages: { ...formState.pages, [step]: { ...formState.pages[step], [field]: value } } });
  };

  const calculatePercentage = (totalStep, step, categoryStep, currentCateTotalStep) => {
    let stepPer = ((step - 1) / totalStep) * 100;
    let cateCount = currentCateTotalStep === 1 ? 1 : ((categoryStep - 0.5) / currentCateTotalStep) * (100 / totalStep);
    return stepPer + cateCount;
  };

  const handleStartOverButtonClick = () =>{
   sessionStorage.removeItem(SESSION_STORAGE_NEEDS_ANALYSIS_KEY);
    setFormState(newFormState)
    props.history.push(`/InsuranceTools/NeedsAnalysis/client-info`);
  }

  const steps = [
    {
      step: 1,
      path: 'client-info',
      progressTitle: 'Basics',
      component: (
        <Steps.ClientBasicInfo
          formState={formState.pages.clientBasicInfo}
          onFieldChange={(field, value) => onFieldChange('clientBasicInfo', field, value)}
          onNext={onNext}
          onBack={onBack}
          ageSpecs={{ min: 0, max: 100 }}
          fullFormState={formState}
          onMultiFieldChange={fs => {
            setFormState(fs);
          }}
          StartOverButton={<StartOverButton  onStartOver={handleStartOverButtonClick}/>}
        />
      ),
      categoryNumber: 1,
      categoryStep: 1,
      hideProgressTracker: false,
      showBasicDetails : false
    },
    {
      step: 2,
      path: 'financial-info',
      progressTitle: 'Financial Information',
      component: (
        <Steps.FinancialInfo
          formState={formState.pages.financialInfo}
          onFieldChange={(field, value) => onFieldChange('financialInfo', field, value)}
          onNext={onNext}
          onBack={onBack}
          fullFormState={formState}
          onMultiFieldChange={fs => {
            setFormState(fs);
          }}
          StartOverButton={<StartOverButton  onStartOver={handleStartOverButtonClick}/>}
        />
      ),
      categoryNumber: 2,
      categoryStep: 1,
      hideProgressTracker: false,
      showBasicDetails : false
    },
    {
      step: 3,
      path: 'current-insurance',
      progressTitle: 'Current Coverage',
      component: (
        <Steps.CurrentInsurance
          formState={formState.pages.currentInsurance}
          onFieldChange={(field, value) => onFieldChange('currentInsurance', field, value)}
          onNext={onNext}
          onBack={onBack}
          fullFormState={formState}
          StartOverButton={<StartOverButton  onStartOver={handleStartOverButtonClick}/>}
        />
      ),
      categoryNumber: 3,
      categoryStep: 1,
      hideProgressTracker: false,
      showBasicDetails : false
    },
    {
      step: 4,
      path: 'additional-info',
      progressTitle: 'Financial Responsibilities',
      component: (
        <Steps.AdditionalClientInfo
          formState={formState.pages.additionalClientInfo}
          onFieldChange={(field, value) => onFieldChange('additionalClientInfo', field, value)}
          onNext={onNext}
          onBack={onBack}
          fullFormState={formState}
          StartOverButton={<StartOverButton  onStartOver={handleStartOverButtonClick}/>}
        />
      ),
      categoryNumber: 4,
      categoryStep: 1,
      hideProgressTracker: false,
      showBasicDetails : false
    },
    {
      step: 5,
      path: 'monthly-expenses',
      progressTitle: 'Basics',
      component: (
        <Steps.MonthlyExpenses
          formState={formState.pages.monthlyExpenses}
          onFieldChange={(field, value) => onFieldChange('monthlyExpenses', field, value)}
          onNext={onNext}
          onBack={onBack}
          fullFormState={formState}
          StartOverButton={<StartOverButton  onStartOver={handleStartOverButtonClick}/>}
        />
      ),
      categoryNumber: 5,
      categoryStep: 1,
      hideProgressTracker: false,
      showBasicDetails : false
    },
    {
      step: 6,
      path: 'quoter',
      progressTitle: 'Basics',
      component: (
        <Steps.Quoter
          fullFormState={formState}
          onMultiFieldChange={fs => {
            setFormState(fs);
          }}
          formState = {formState.pages.quoter}
          history = {props.history}
          onBack={onBack}
          onNext={onNext}
        />
      ),
      categoryNumber: 6,
      categoryStep: 6,
      hideProgressTracker: true,
      showBasicDetails:true,
    },
    {
      step: 7,
      path: 'product-advisor',
      progressTitle: 'Product advisor',
      component: (
        <Steps.Advisor
          history = {props.history}
          formState={formState.pages.advisor}
          onBack={onBack}
          fullFormState = {formState}
        />
      ),
      showBasicDetails : true,
      categoryNumber: 6,
      categoryStep: 6,
      hideProgressTracker: true,
      hideHeader : true,
    },
  ];

  const currentStepObj = steps.find(s => s.step === formState.currentStep) || steps[0];
  const categories = steps.filter(o => o.categoryNumber === currentStepObj.categoryNumber);
  const totalCategoriesStep = Math.max.apply(
    Math,
    categories.map(function(o) {
      return o.categoryStep;
    })
  );
  const percent = calculatePercentage(5, currentStepObj.categoryNumber, currentStepObj.categoryStep, totalCategoriesStep);
  return (
    <div className = 'needanalysis-form'>
      <Helmet>
        <title>Needs Analysis</title>
       </Helmet>
      <HeaderProgressTracker
        breadCrumb={`NEEDS ANALYSIS`}
        breadcrumbLink={[{ name: 'TOOLS', href: '/ResourceCenter' }]}
        currentPage={true}
        title="Needs Analysis"
        showContainer={false}
        hideProgressTracker={currentStepObj.hideProgressTracker}
        showBasicDetails={currentStepObj.showBasicDetails}
        headerProductsText={true}
        stepName={currentStepObj.progressTitle}
        step={currentStepObj.categoryNumber}
        totalSteps={5}
        percent={percent}
        fullFormState={formState}
        onStartOver={handleStartOverButtonClick}
        hideHeader = {currentStepObj.hideHeader}
      >
        {currentStepObj.component}
      </HeaderProgressTracker>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/InsuranceTools/NeedsAnalysis/NeedsAnalysis.js